// usernames can comprise only lowercase alphabet characters, numbers, _, '.' and -, and must be between 6 to 20 chars
const usernameOK = /^[a-z0-9-_\.]{6,20}$/

// from https://emailregex.com/
const emailOK = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export { usernameOK, emailOK }
